import { orderStatus } from "./index";

export const validItem = (item = {}) => {
  // const rdcQty = item?.RdcQty || 0;
  // const orderQty = item?.orderQty || 0;
  // const status = item?.ReleaseStatus || "";

  // if (rdcQty === 0 || orderQty === 0 || status === ORDER_STATUS.released) {
  //   return undefined;
  // }

  // if (orderQty <= rdcQty) {
  //   return item?.id;
  // }

  return item?.id;
  // return undefined;
};

export const validPogItem = (item = {}) => {
  return item?.ReleaseStatus !== orderStatus.released && !item?.IsFromFillIn;
};
